/** Componsante Tab de TimTools */
export default class Tabs {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    this.element = element;
    this.btns = this.element.querySelectorAll('.js-tab');
    this.contents = this.element.querySelectorAll('.js-content');
    this.actif = 0;

    this.init();
  }

  /**
   * Méthode d'initialisation
   */
  init() {
    //const btns = this.element.querySelectorAll('.js-tab');
    for (let i = 0; i < this.btns.length; i++) {
      this.btn = this.btns[i];
      this.btn.addEventListener('click', this.clickBtn.bind(this));
    }
  }
  /**
   * clickBtn, Permet de cibler le bouton qui vas passer de pas actif a 'is-active' en lui ajoutans la class 'is-active'
   * @param {event} e - permet de pass l'évenement click sur le '.js-tab'
   */
  clickBtn(e) {
    this.target = e.target;
    if (this.target.classList.contains('is-active')) {
      
    } else {
      this.target.classList.add('is-active');
    }
    this.afficheLeBon();
  }
  /**
   * afficheLeBon, Peermet de rendre actif seulement le bon element et enleve la class 'is-active' au autres elements
   *
   */
  afficheLeBon() {
    this.actif = this.target.getAttribute('data-tab-content-id');

    for (let i = 0; i < this.btns.length; i++) {
      const btn = this.btns[i];
      if (btn.getAttribute('data-tab-content-id') != this.actif) {
        btn.classList.remove('is-active');
      }
    }
    this.lierBtnContent();
  }
  /**
   * LierBtnContent, Permtet de lier le bt actif et le content actif
   * @param {type} name - description
   */
  lierBtnContent() {
    for (let i = 0; i < this.contents.length; i++) {
      const content = this.contents[i];
      if (content.getAttribute('data-tab-content-id') == this.actif) {
        content.classList.add('is-active');
      } else {
        content.classList.remove('is-active');
      }
    }
  }
}
